<template>
  <div class="message">
    <div class="box">
      <div class="header">
        <div class="title">在线留言</div>
        <div class="border"></div>
      </div>
      <div class="body">
        <div class="describe">
          <div>需求描述</div>
          <el-input
            v-model="dataForm.requirement"
            type="textarea"
            placeholder="请输入您的需求描述"
            :autosize="{ minRows: 6, maxRows: 8 }"
            :style="{ width: '100%' }"
          />
        </div>

        <div class="interest">
          <div class="interest_title">您感兴趣的产品或服务</div>

          <div class="hardware">
            <div class="interest_name">硬件</div>
            <el-checkbox-group v-model="dataForm.hardware">
              <el-checkbox
                v-for="(item, index) in hardwareList"
                :key="index"
                :label="item.productName"
                >{{ item.productName }}</el-checkbox
              >
            </el-checkbox-group>
          </div>

          <div class="interest_border"></div>

          <div class="software">
            <div class="interest_name">软件</div>
            <el-checkbox-group v-model="dataForm.software">
              <el-checkbox
                v-for="(item, index) in softwareList"
                :key="index"
                :label="item.productName"
                >{{ item.productName }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </div>

        <div class="flex">
          <div class="item">
            <div>姓名</div>
            <el-input
              v-model="dataForm.realName"
              type="text"
              placeholder="请输入您的姓名"
            />
          </div>
          <div class="item">
            <div>联系方式</div>
            <el-input
              v-model="dataForm.phone"
              type="text"
              placeholder="请输入您的联系方式"
            />
          </div>
        </div>
        <div class="flex">
          <div class="item">
            <div>企业名称</div>
            <el-input
              v-model="dataForm.texture"
              type="text"
              placeholder="请输入您的企业名称"
            />
          </div>
          <div class="item">
            <div>咨询信息</div>
            <el-input
              v-model="dataForm.consultInfo"
              type="text"
              placeholder="请输入您想咨询的信息"
            />
          </div>
        </div>

        <button @click="formSubmit()">在线留言</button>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";
import axios from "axios";

export default {
  setup() {
    return reactive({
      dataForm: {
        requirement: "",
        hardware: [],
        software: [],
        realName: "",
        phone: "",
        texture: "",
        consultInfo: "",
        productName: [],
      },
      hardwareList: [],
      softwareList: [],
    });
  },
  created() {
    this.getHardware();
    this.getSoftware();
  },
  methods: {
    getHardware() {
      axios
        .get(
          "https://zhihui.shchangju.com/api/renren-fast/cywebsite/cyproduct/list?product_type=1&limit=999"
        )
        .then((res) => {
          console.log(res);
          this.hardwareList = res.data.page.list;
        });
    },
    getSoftware() {
      axios
        .get(
          "https://zhihui.shchangju.com/api/renren-fast/cywebsite/cyproduct/list?product_type=2&limit=999"
        )
        .then((res) => {
          console.log(res);
          this.softwareList = res.data.page.list;
        });
    },
    formSubmit() {
      if (this.dataForm.requirement == "") {
        this.$message.error("请输入您的需求描述");
        return;
      }
      if (
        this.dataForm.hardware.length == 0 &&
        this.dataForm.software.length == 0
      ) {
        this.$message.error("请选择您感兴趣的产品或者服务");
        return;
      }
      if (this.dataForm.realName == "") {
        this.$message.error("请输入您的姓名");
        return;
      }
      if (this.dataForm.phone == "") {
        this.$message.error("请输入您的联系方式");
        return;
      }
      if (this.dataForm.texture == "") {
        this.$message.error("请输入您的企业名称");
        return;
      }
      if (this.dataForm.consultInfo == "") {
        this.$message.error("请输入您想咨询的信息");
        return;
      }
      this.dataForm.productName = this.dataForm.hardware
        .concat(this.dataForm.software)
        .toString();
      axios
        .post(
          "https://zhihui.shchangju.com/api/renren-fast/cywebsite/cycontactsheet/save",
          this.dataForm
        )
        .then((res) => {
          console.log(res);
          if (res.data.code != 0) {
            this.$message.error(res.data.msg);
            return;
          }
          this.$message.success("留言成功，感谢您的留言");
          this.dataForm = {
            requirement: "",
            hardware: [],
            software: [],
            realName: "",
            phone: "",
            texture: "",
            consultInfo: "",
            productName: [],
          };
        });
    },
  },
};
</script>

<style scoped>
.message {
  width: 1180px;
  height: 100%;
  margin: 80px auto;
  background-image: url(../../../assets/contact/messageBack.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.message .box {
  padding: 60px 100px;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}
.body {
  text-align: center;
}
.body .flex {
  display: flex;
  justify-content: space-between;
}
.body .flex .item,
.describe,
.interest_title {
  margin-top: 20px;
}
.describe div,
.interest_title {
  text-align: left;
  margin-bottom: 10px;
  font-size: 18px;
  color: #333;
}
.body .flex .item div {
  text-align: left;
  font-size: 18px;
  color: #333;
  margin-bottom: 10px;
}
:deep(.el-input__inner) {
  width: 380px;
  padding: 10px 0;
  border: none;
  outline: none;
  font-size: 18px;
}

.body button {
  width: 272px;
  height: 54px;
  margin-top: 60px;
  background: #248efb;
  border-radius: 10px 10px 10px 10px;
  border: none;
  color: #fff;
  font-size: 20px;
}

.interest {
  text-align: left;
}
.interest_border {
  width: 100%;
  border-top: 1px solid #d8d8d8;
  margin: 10px 0;
}
.interest_name {
  font-size: 18px;
  color: #b6bec7;
}
:deep(.el-checkbox__inner) {
  width: 18px;
  height: 18px;
}
:deep(.el-checkbox__label) {
  font-size: 16px;
  color: #b6bec7;
}
:deep(.el-checkbox__inner::after) {
  height: 9px;
  left: 6px;
}
</style>
